import { IResourceComponentsProps, useExport, useGetIdentity, useList, useNavigation } from '@pankod/refine-core'
import { CSVLink } from 'react-csv'
import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  Input,
  Divider,
  useTable,
  Form,
  Button,
  ImportButton,
  useImport,
  message,
} from '@pankod/refine-antd'
// import { useTable } from '@pankod/refine-core'
import { IProject, IReportTheme, ITheme, ITopic } from 'interfaces'
import { CreateReportTheme } from './create'
import { EditReportTheme } from './edit'
import metaData from 'metadata/reportThemes'
import { useUserContext } from 'context/user'
import { useEffect, useState } from 'react'
import Permissions from 'permissions'
import { createUserHistory } from 'gql/mutations'
import { reportThemeImportFomart } from 'helpers/import_template_format/importTemplate'


type Permission = {
  granted?: boolean
}
const { PlusOutlined, ExportOutlined } = Icons

export const ReportThemesList: React.FC<IResourceComponentsProps> = () => {
  const [readPermission, setReadPermission] = useState<Permission>({})
  const { data: user } = useGetIdentity()
  const { userRole } = useUserContext()
  const hiddenRole = ['srmanager']
  const [pagination, setHasPagination] = useState<any>(true)
  const { push } = useNavigation()
  // const { queryResult: projectQueryResult } = useProjectsConfig(true)

  const { tableProps, searchFormProps, sorter, tableQueryResult, setFilters } = useTable<IReportTheme>({
    hasPagination: pagination,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    metaData,
    onSearch: (values: any) => {
      return [
        {
          field: 'name',
          operator: 'contains',
          value: `%${values.title}%`,
        },
      ]
    },
  })

  const themeLists = useList<ITheme>({
    resource: 'themes',
    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      pagination: { pageSize: 100000 },
    },
  })

  const { formProps, modalProps, show } = useModalForm({
    resource: 'report_themes',
    action: 'create',
  })
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
  } = useModalForm({
    resource: 'report_themes',
    action: 'edit',
    metaData,
  })
  useEffect(() => {
    if (userRole !== undefined) {
      setReadPermission(Permissions.can(userRole).readAny('report_themes'))
    }
  }, [userRole])
  useEffect(() => {
    if (!readPermission?.granted && readPermission?.granted !== undefined) push('/')
  }, [readPermission, userRole])

  const hideDeleteButton = (record: IReportTheme): boolean => {
    const { work_requests: wr, questions: q } = record
    if (wr !== undefined && q !== undefined) {
      const shouldHide = wr.length > 0 || q.length > 0
      return shouldHide
    }
    return false
  }

  const { triggerExport, isLoading } = useExport<IReportTheme>({
    metaData: {
      fields: ['id', 'name', 'theme_ids'],
      // fields: ['id', 'name', 'subject_id'],
    },
  })

  useEffect(() => {
    if (isLoading) createUserHistory('report_themes', 'export', '', user?.id, userRole)
  }, [isLoading])

  const importProps = useImport<IReportTheme>({
    mapData: item => {
      let newThemeIds = []
      const isRowEmpty = (item: any) => {
        return Object.values(item).every(field => field === '' || field === undefined)
      }
      const rowEmpty = isRowEmpty(item)
      if (!rowEmpty) {
        newThemeIds = item?.theme_ids?.split(',')
        if (newThemeIds.length) {
          return {
            name: item.name,
            // subject_id: item.subject_id,
            theme_ids: newThemeIds,
            created_by: user?.id,
          }
        }
      }
    },

    onFinish: result => {
      result.errored.forEach(item => {
        message.error('Failed to upload report theme')
      })
    },
  })
  //csv data format
  const csvData = [reportThemeImportFomart.map(item => item.toString())]

  const renderItems = (item: any, typeIs: string) => {
    let subject_text: string = ''
    if (typeIs === 'theme') {
      if (item?.length) {
        for (let i = 0; i < item.length; i++) {
          const checkingList: any = themeLists || []
          let result = checkingList?.data?.data?.filter((subjects: any) => item[i] === subjects?.id)[0]
          if (result !== undefined) {
            subject_text = subject_text?.concat(result?.name)
            subject_text = subject_text.concat(',')
          }
        }
      }
      subject_text = subject_text.substring(0, subject_text.length - 1)
      return subject_text
    } else if (typeIs === 'projects') {
      // if (item) {
      //   const projectList = projectQueryResult?.data?.data || []
      //   projectList.forEach((project: any) => {
      //     if (project?.report_theme_ids?.length > 0 && project?.report_theme_ids.includes(item)) {
      //       subject_text = subject_text?.concat(project?.name)
      //       subject_text = subject_text.concat(',')
      //     }
      //   })
      // }
      // subject_text = subject_text.substring(0, subject_text.length - 1)
      // return subject_text
    }
  }
  // refetch project deatils
  // const refetchProjectDetails = () => {
  //   projectQueryResult.refetch()
  // }

  return (
    <List
      pageHeaderProps={{
        extra: [
          userRole === 'admin' && <ImportButton {...importProps} />,
          <ExportButton onClick={triggerExport} loading={isLoading} hidden={hiddenRole?.includes(userRole)} />,
          <RefreshButton onClick={() => tableQueryResult?.refetch()} />,
          <CreateButton type="primary" icon={<PlusOutlined />} onClick={() => show()} />,
        ],
      }}
    >
      <Form {...searchFormProps}>
        <Space>
          <Form.Item name="title">
            <Input
              placeholder="Search by title"
              allowClear
              onChange={e => {
                if (e.type === 'click') {
                  searchFormProps.form?.submit()
                }
              }}
            />
          </Form.Item>
          <Button icon={<Icons.SearchOutlined />} onClick={searchFormProps.form?.submit}>
            Search
          </Button>
          <Button key="export paper" type="default" style={{ marginLeft: '5px' }}>
            <CSVLink key="export" data={csvData} filename={`report_theme_ImportFormat${Math.round(new Date().getTime() / 1000)}`}>
              <ExportOutlined /> Download Import Format
            </CSVLink>
          </Button>
        </Space>
      </Form>
      <Divider />
      <Table {...tableProps}>
        <Table.Column dataIndex="name" title="Name" />

        {/* <Table.Column<IReportTheme> dataIndex="project_ids" render={(_, record) => renderItems(record?.id, 'projects')} title="Projects" /> */}
        <Table.Column<IReportTheme> dataIndex="theme_ids" render={(_, record) => renderItems(record?.theme_ids, 'theme')} title="Themes" />
        <Table.Column
          dataIndex="created_at"
          title="Created At"
          render={value => <DateField value={value} format="LLL" />}
          defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
          sorter
        />
        <Table.Column<IReportTheme>
          title="Actions"
          dataIndex="actions"
          key="actions"
          render={(_, record) => (
            <Space>
              <EditButton size="small" type="link" icon={null} recordItemId={record.id} onClick={() => editShow(record.id)} />
              <DeleteButton size="small" type="link" icon={null} recordItemId={record.id} hidden={hideDeleteButton(record)} />
            </Space>
          )}
        />
      </Table>
      <CreateReportTheme modalProps={modalProps} formProps={formProps} />
      <EditReportTheme modalProps={editModalProps} formProps={editFormProps} />
    </List>
  )
}
